/* assets/armonia-live-strip.js
   1) Durata del marquee in base alla larghezza reale di un gruppo e alla velocita (px/s) desktop/mobile.
   2) Stato del pallino LIVE: "live" (verde) durante la finestra di diretta, "idle" (rosso) altrimenti.
      Finestra = giorno + orario + durata impostati nella section, nel fuso orario del negozio.
      Se e' impostata una data singola (AAAA-MM-GG), vale quella al posto del giorno settimanale. */
(function () {
  'use strict';

  var DAYS = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];

  /* ---------- Velocita marquee ---------- */
  function applySpeed(root) {
    var track = root.querySelector('.armonia-live__track');
    var group = root.querySelector('.armonia-live__group');
    if (!track || !group) return;
    var isDesktop = window.matchMedia && window.matchMedia('(min-width: 750px)').matches;
    var speed = parseFloat(root.getAttribute(isDesktop ? 'data-speed-desktop' : 'data-speed-mobile')) || 40;
    var width = group.getBoundingClientRect().width;
    if (!width) return;
    track.style.animationDuration = Math.max(width / speed, 5).toFixed(1) + 's';
  }

  /* ---------- Stato LIVE ---------- */
  function zonedNow(tz) {
    var parts;
    try {
      parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: tz,
        weekday: 'short',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23'
      }).formatToParts(new Date());
    } catch (e) {
      return null;
    }
    var o = {};
    parts.forEach(function (p) { o[p.type] = p.value; });
    return {
      day: String(o.weekday || '').slice(0, 3).toLowerCase(),
      date: o.year + '-' + o.month + '-' + o.day,
      minutes: parseInt(o.hour, 10) * 60 + parseInt(o.minute, 10)
    };
  }

  function shiftDate(iso, deltaDays) {
    var p = iso.split('-');
    var d = new Date(Date.UTC(+p[0], +p[1] - 1, +p[2] + deltaDays));
    function z(n) { return (n < 10 ? '0' : '') + n; }
    return d.getUTCFullYear() + '-' + z(d.getUTCMonth() + 1) + '-' + z(d.getUTCDate());
  }

  function isLive(root) {
    var tz = root.getAttribute('data-timezone') || 'Europe/Rome';
    var start = (root.getAttribute('data-start') || '').match(/^(\d{1,2}):(\d{2})$/);
    var duration = parseInt(root.getAttribute('data-duration'), 10);
    if (!start || !duration) return false;
    var s = parseInt(start[1], 10) * 60 + parseInt(start[2], 10);
    var e = s + duration;
    var now = zonedNow(tz);
    if (!now) return false;

    var oneOff = (root.getAttribute('data-date') || '').trim();
    var todayMatch, yesterdayMatch;
    if (/^\d{4}-\d{2}-\d{2}$/.test(oneOff)) {
      todayMatch = now.date === oneOff;
      yesterdayMatch = shiftDate(now.date, -1) === oneOff;
    } else {
      var day = root.getAttribute('data-day') || 'tue';
      var idx = DAYS.indexOf(now.day);
      todayMatch = now.day === day;
      yesterdayMatch = idx > -1 && DAYS[(idx + 6) % 7] === day;
    }

    if (todayMatch && now.minutes >= s && now.minutes < e) return true;
    /* La diretta passa la mezzanotte (es. 23:30 + 60 min) */
    if (yesterdayMatch && e > 1440 && now.minutes < e - 1440) return true;
    return false;
  }

  function applyState(root) {
    var live = isLive(root);
    var next = live ? 'live' : 'idle';
    if (root.getAttribute('data-state') !== next) {
      root.setAttribute('data-state', next);
      var status = root.querySelector('[data-armonia-live-status]');
      if (status) status.textContent = status.getAttribute(live ? 'data-label-live' : 'data-label-idle') || '';
    }
  }

  function init() {
    document.querySelectorAll('[data-armonia-live]').forEach(function (root) {
      applySpeed(root);
      applyState(root);
    });
  }

  var timer;
  window.addEventListener('resize', function () {
    clearTimeout(timer);
    timer = setTimeout(init, 150);
  });
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) init();
  });
  setInterval(function () {
    document.querySelectorAll('[data-armonia-live]').forEach(applyState);
  }, 30000);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(init);
  init();
})();
